<template>
    <!-- ------------------------------------- 首页 ----------------------------------- -->
    <div class="index">
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Header></Header>

        <!-- ---------------------------------- 轮播海报 ---------------------------------- -->
        <div v-if="imgList4.length > 1" class="banner">
            <el-carousel style="height: 100%">
                <el-carousel-item
                    v-for="(item, index) in imgList4"
                    :key="index"
                    style="height: 100%"
                >
                    <div class="banner_box" v-if="index === 0">
                        <img
                            @click="tiaoZhuan(index)"
                            v-if="
                                item.imgUrl.toString().split('.')[
                                    item.imgUrl.toString().split('.').length - 1
                                ] === 'png'
                            "
                            v-lazy="
                                'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                item.imgUrl
                            "
                            alt=""
                        />

                        <div class="propk" v-if="item.video">
                            <div
                                style="
                                    position: absolute;
                                    top: -500%;
                                    z-index: 11;
                                    left: 18%;
                                "
                            >
                                <video
                                    autoplay="autoplay"
                                    :src="item.video"
                                    v-show="show2"
                                    @click="showCont"
                                ></video>
                            </div>

                            <!-- <iframe :src="item.video" frameborder="0" width="600%" height="600"></iframe> -->

                            <img
                                src="../assets/images/bofang.png"
                                slot="reference"
                                class="bfbtn"
                                @click="showCont"
                            />
                        </div>

                        <p class="slogan_one">蔚然新创<span>·</span>诺守健康</p>
                    </div>
                    <div class="banner_box" v-if="index === 1">
                        <img
                            @click="tiaoZhuan(index)"
                            v-if="
                                item.imgUrl.toString().split('.')[
                                    item.imgUrl.toString().split('.').length - 1
                                ] === 'png'
                            "
                            v-lazy="
                                'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                item.imgUrl
                            "
                            alt=""
                        />

                        <div class="propk" v-if="item.video">
                            <div
                                style="
                                    position: absolute;
                                    top: -500%;
                                    z-index: 11;
                                    left: 18%;
                                "
                            >
                                <video
                                    autoplay="autoplay"
                                    :src="item.video"
                                    v-show="show2"
                                    @click="showCont"
                                ></video>
                            </div>
                            <!-- <iframe :src="item.video" frameborder="0" width="600%" height="600"></iframe> -->
                            <img
                                @click="showCont"
                                src="../assets/images/bofang.png"
                                slot="reference"
                                class="bfbtn"
                            />
                        </div>

                        <span class="slogan_two">拥抱</span>
                        <span class="slogan_tree">蓝天绿地</span>
                    </div>
                    <div class="banner_box" v-if="index === 2">
                        <img
                            @click="tiaoZhuan(index)"
                            v-if="
                                item.imgUrl.toString().split('.')[
                                    item.imgUrl.toString().split('.').length - 1
                                ] === 'png'
                            "
                            v-lazy="
                                'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                item.imgUrl
                            "
                            alt=""
                        />
                        <div class="propk" v-if="item.video">
                            <div
                                style="
                                    position: absolute;
                                    top: -500%;
                                    z-index: 11;
                                    left: 18%;
                                "
                            >
                                <video
                                    autoplay="autoplay"
                                    :src="item.video"
                                    v-show="show2"
                                    @click="showCont"
                                ></video>
                            </div>
                            <!-- <iframe :src="item.video" frameborder="0" width="600%" height="600"></iframe> -->
                            <img
                                @click="showCont"
                                src="../assets/images/bofang.png"
                                slot="reference"
                                class="bfbtn"
                            />
                        </div>
                        <span class="slogan_four">呼吸得到的</span>
                        <span class="slogan_five">美感生活</span>
                    </div>
                    <div class="banner_box" v-if="index === 3">
                        <img
                            @click="tiaoZhuan(index)"
                            v-if="
                                item.imgUrl.toString().split('.')[
                                    item.imgUrl.toString().split('.').length - 1
                                ] === 'png'
                            "
                            v-lazy="
                                'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                item.imgUrl
                            "
                            alt=""
                        />
                        <div class="propk" v-if="item.video">
                            <div
                                style="
                                    position: absolute;
                                    top: -500%;
                                    z-index: 11;
                                    left: 18%;
                                "
                            >
                                <video
                                    autoplay="autoplay"
                                    :src="item.video"
                                    v-show="show2"
                                    @click="showCont"
                                ></video>
                            </div>
                            <!-- <iframe :src="item.video" frameborder="0"  width="600%" height="600"></iframe> -->
                            <img
                                @click="showCont"
                                src="../assets/images/bofang.png"
                                slot="reference"
                                class="bfbtn"
                            />
                        </div>
                        <span class="slogan_six">智造绿色生活</span>
                        <span class="slogan_seven">优质空气测检服务</span>
                    </div>
                    <video
                        class="banner_box"
                        controls="controls"
                        v-if="
                            item.imgUrl.toString().split('.')[
                                item.imgUrl.toString().split('.').length - 1
                            ] === 'mp4'
                        "
                        v-lazy="
                            'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                            item.imgUrl
                        "
                    ></video>
                </el-carousel-item>
            </el-carousel>
            <!-- <swiper :options="swiperOption">
                      <swiper-slide v-for="(item, index) in imgList4" :key="index">
                          <div class="banner_box" v-if="index === 0">
                              <img @click="tiaoZhuan(index)" v-if="item.imgUrl.toString().split('.')[item.imgUrl.toString().split('.').length-1] === 'png'" :src="'http://118.89.87.102:8080/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">
                              <p class="slogan_one">蔚然新创<span>·</span>诺守健康</p>
                          </div>
                          <div class="banner_box" v-if="index === 1">
                              <img @click="tiaoZhuan(index)" v-if="item.imgUrl.toString().split('.')[item.imgUrl.toString().split('.').length-1] === 'png'" :src="'http://118.89.87.102:8080/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">
                              <span class="slogan_two">拥抱</span>
                              <span class="slogan_tree">蓝天绿地</span>
                          </div>
                          <div class="banner_box" v-if="index === 2">
                              <img @click="tiaoZhuan(index)" v-if="item.imgUrl.toString().split('.')[item.imgUrl.toString().split('.').length-1] === 'png'" :src="'http://118.89.87.102:8080/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">
                              <span class="slogan_four">呼吸得到的</span>
                              <span class="slogan_five">美感生活</span>
                          </div>
                          <div class="banner_box" v-if="index === 3">
                              <img @click="tiaoZhuan(index)" v-if="item.imgUrl.toString().split('.')[item.imgUrl.toString().split('.').length-1] === 'png'" :src="'http://118.89.87.102:8080/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">
                              <span class="slogan_six">智造绿色生活</span>
                              <span class="slogan_seven">优质空气测检服务</span>
                          </div>
                          <video class="banner_box" controls="controls" v-if="item.imgUrl.toString().split('.')[item.imgUrl.toString().split('.').length-1] === 'mp4'" :src="'http://118.89.87.102:8080/jeecg-boot/sys/common/static/'+item.imgUrl"></video>
                      </swiper-slide>
                      <div class="swiper-pagination" slot="pagination"></div>
                      <div class="swiper-button-prev" slot="button-prev"></div>
                      <div class="swiper-button-next" slot="button-next"></div>
                  </swiper>
                  &lt;!&ndash;如果你需要分页&ndash;&gt;
                  <div class="swiper-pagination" slot="pagination"></div>
                  &lt;!&ndash;如果需要前进后退按钮&ndash;&gt;
                  <div class="swiper-button-next2"></div>
                  <div class="swiper-button-prev2"></div>-->
        </div>
        <div v-else-if="imgList4.length <= 1">
            <div v-for="(item, index) in imgList4" :key="index">
                <img
                    class="banner"
                    @click="tiaoZhuan(index)"
                    v-lazy="
                        'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                        item.imgUrl
                    "
                    alt=""
                />
                <p
                    style="
                        margin: 5% 0;
                        position: absolute;
                        top: 65%;
                        color: #fff;
                        font-size: 50px;
                        left: 38%;
                    "
                    v-html="item.remarks"
                ></p>
            </div>
        </div>
        <!-- ---------------------------------- 宣传标语 ---------------------------------- -->
        <div class="propaganda">
            <p>
                我们相信Renaud的可持续发展愿景紧贴业务重点，<br />矢志塑造出更美好纯净生活，迈向永续绿色未来。
            </p>
        </div>
        <!-- ---------------------------------- 产品展示 ---------------------------------- -->
        <div class="product">
            <TransverseRotation :list="list2"></TransverseRotation>
        </div>
        <!-- ---------------------------------- 产品理念 ---------------------------------- -->
        <!-- ---------------------------------- 产品关怀 ---------------------------------- -->
        <div class="care">
            <!-- 背景图 -->
            <img class="care_bg" src="../assets/images/index-care.png" alt="" />
            <!-- 内容 -->
            <div class="care_main">
                <!-- LOGO -->
                <img
                    class="care_logo"
                    src="../assets/images/icon/renoud-logo-orange.png"
                    alt=""
                />
                <!-- 空检、维修、保养 -->
                <div class="care_box">
                    <div>空检</div>
                    <div class="vertical">维修</div>
                    <div>保养</div>
                </div>
                <!-- 播放图标 -->
                <img
                    @click="toCare()"
                    class="care_play"
                    src="../assets/images/icon/play-blue.png"
                    alt=""
                />
            </div>
        </div>
        <!-- ---------------------------------- 2D体验馆 ---------------------------------- -->
        <div class="experience">
            <!-- 背景图 -->
            <img
                class="experience_bg"
                src="../assets/images/index-2d.png"
                alt=""
            />
            <!-- 内容 -->
            <div class="experience_main">
                <!-- 文案 -->
                <p>
                    方便快捷在线小功能，帮您提前规划<br />空气净化器放置的位置。2D体验馆为你<br />创建个人化的居室，检视产品的细节。
                </p>
                <!-- 图标 -->
                <img
                    class="corrugated"
                    src="../assets/images/icon/corrugated.png"
                    alt=""
                />
                <!-- 标题 -->
                <!-- <a-popconfirm title="即将上线，敬请期待" style="width:100%" class="propcon">
                      -->
                <!--        <el-dialog-->
                <!--          title="提示"-->
                <!--          :visible.sync="centerTygVisible"-->
                <!--          width="25%"-->
                <!--          center-->
                <!--        >-->
                <!--          <p>即将上线，敬请期待</p>-->
                <!--        </el-dialog>-->
                <div @click="toExperience">2D 体 验 馆</div>
                <!-- 播放图标 -->
                <img
                    @click="toExperience"
                    class="experience_play"
                    src="../assets/images/icon/play-white.png"
                    alt=""
                />
                <!-- </a-popconfirm>  -->
            </div>
        </div>
        <!-- ---------------------------------- 空气检测服务 ---------------------------------- -->
        <div class="service">
            <!-- 左侧标语 -->
            <div class="service_slogan">
                <span>今天来拥抱·清新的空气</span>
            </div>
            <!-- 右侧表单 -->
            <div class="service_form">
                <!-- 标题 -->
                <div class="form_title">
                    <p @click="toDetection()">空气检测服务</p>
                    <img
                        @click="toDetection()"
                        src="../assets/images/icon/play-white.png"
                        alt=""
                    />
                </div>
                <!-- 表单 -->
                <!-- 表单 -->
                <div class="index-qi-pa-rig-san-quyu">
                    <!-- 请选择省份 -->
                    <div class="index-quyu-ss">
                        <img
                            src="../assets/images/icon/dizhi-pic-new.png"
                            class="form-icon"
                            alt=""
                        />
                        <el-select
                            v-model="formData1.provinceValue"
                            placeholder="请选择省份"
                            @change="getCity"
                            class="index-quyu-xiala"
                        >
                            <el-option
                                v-for="(item, index) in provinceArr"
                                :key="index"
                                :label="item.provinceCn"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <!-- 请选择城市 -->
                    <div class="index-quyu-ss">
                        <img
                            src="../assets/images/icon/chengshi-new.png"
                            alt=""
                            class="form-icon"
                        />
                        <el-select
                            v-model="formData1.cityValue"
                            placeholder="请选择城市"
                            no-data-text="无数据"
                            class="index-quyu-xiala"
                        >
                            <el-option
                                v-for="(item, index) in cityArr"
                                :key="index"
                                :label="item.cityCn"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <!-- 请输入姓名 -->
                    <div class="index-quyu-ss">
                        <img
                            src="../assets/images/icon/yh-new.png"
                            alt=""
                            class="form-icon"
                        />
                        <el-input
                            placeholder="请输入姓名"
                            style="outline: none"
                            v-model="formData1.nameValue"
                        ></el-input>
                        <!-- <input
                            type="text"
                            placeholder="请输入姓名"
                            v-model="formData1.nameValue"
                            class="index-quyu-xiala"
                            style="outline: none"
                        /> -->
                    </div>
                    <!-- 请输入手机号 -->
                    <div class="index-quyu-ss">
                        <img
                            src="../assets/images/icon/sj-new.png"
                            alt=""
                            class="form-icon"
                        />
                        <el-input
                            style="outline: none"
                            placeholder="请输入手机号"
                            v-model="formData1.phoneValue"
                            @blur="phoneRule"
                        ></el-input>
                        <!-- <input
                            type="text"
                            placeholder="请输入手机号"
                            v-model="formData1.phoneValue"
                            class="index-quyu-xiala"
                            style="outline: none"
                            @blur="phoneRule"
                        /> -->
                    </div>
                    <!-- 邀请码 -->
                    <div class="index-quyu-ss">
                        <img
                            src="../assets/images/icon/yq-new.png"
                            alt=""
                            class="form-icon"
                        />
                        <!-- <input type="text" placeholder="邀请码" class="index-quyu-xiala" style="padding-left:13px;outline:none;"> -->
                        <el-select
                            v-model="formData1.code"
                            @change="qingKong"
                            placeholder="邀请码"
                            class="index-quyu-xiala"
                        >
                            <el-option :value="1" label="没有">没有</el-option>
                            <el-option :value="2" label="有">有</el-option>
                            <!--              <el-option :value="3" label="不清楚">不清楚</el-option>-->
                        </el-select>
                        <el-select
                            v-if="formData1.code === 1"
                            v-model="formData1.codeTwo"
                            placeholder="选择"
                        >
                            <el-option :value="1" label="确定没有"
                                >确定没有</el-option
                            >
                            <el-option :value="2" label="不清楚"
                                >不清楚</el-option
                            >
                        </el-select>
                        <el-input
                            v-if="formData1.code === 2"
                            v-model="formData1.codeTwo"
                            :value="0"
                            placeholder="请输入邀请码"
                        ></el-input>
                    </div>
                    <!-- 立即安排 -->
                    <div>
                        <a class="index-quyu-btt" @click="yyAirjiance">
                            立即安排
                            <span style="margin-left: 10px">></span></a
                        >
                    </div>
                </div>
            </div>
        </div>
        <!-- ---------------------------------- 企业资讯 ---------------------------------- -->
        <div class="information">
            <!-- 资讯 -->
            <div class="information_main">
                <!-- 标题 -->
                <p class="infor_title">企业资讯</p>
                <!-- 横线 -->
                <div class="infor_line"></div>
                <!-- 内容 -->
                <div
                    class="infor_content"
                    style="width: 50%"
                    v-if="info.length === 1"
                >
                    <!-- 资讯一 -->
                    <div class="content_main">
                        <div class="infor_main_box">
                            <!-- 文字 -->
                            <p>{{ info[0].title.substring(0, 36) }}</p>
                            <!-- 图片 -->
                            <em
                                :style="{
                                    backgroundImage: `url('${api.ip}${api.imgSrc}${info[0].cover}')`,
                                }"
                                class="infoImage"
                            ></em>
                            <!-- 按钮 -->
                            <div>
                                <span  @click="toInforMain(info[0].id)"
                                    >继续阅读 ></span
                                >
                            </div>
                        </div>
                    </div>
                    <!-- 竖线 -->
                    <div class="content_line"></div>
                    <!-- 资讯二 -->
                    <div class="content_main" v-if="info.length === 2">
                        <div class="infor_main_box">
                            <!-- 文字 -->
                            <p>{{ info[1].title.substring(0, 36) }}</p>
                            <!-- 图片 -->
                            <em
                                :style="{
                                    backgroundImage: `url('${api.ip}${api.imgSrc}${info[1].cover}')`,
                                }"
                                class="infoImage"
                            ></em>
                            <!-- 按钮 -->
                            <div>
                                <span @click="toInforMain(info[1].id)"
                                    >继续阅读 ></span
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 更多按钮 -->
                <div class="infor_content" v-else-if="info.length">
                    <!-- 资讯一 -->
                    <div class="content_main">
                        <!-- 文字 -->
                        <p>{{ info[0].title.substring(0, 36) }}</p>
                        <!-- 图片 -->
                        <em
                            :style="{
                                backgroundImage: `url('${api.ip}${api.imgSrc}${info[0].cover}')`,
                            }"
                            class="infoImage"
                        ></em>
                        <!-- 按钮 -->
                        <div class="readContine_new">
                            <span class="readTitle" @click="toInforMain(info[0].id)"
                                >继续阅读 ></span
                            >
                        </div>
                    </div>
                    <!-- 竖线 -->
                    <div class="content_line"></div>
                    <!-- 资讯二 -->
                    <div class="content_main" v-if="info.length === 2">
                        <!-- 文字 -->
                        <p>{{ info[1].title.substring(0, 36) }}</p>
                        <!-- 图片 -->
                        <em
                            :style="{
                                backgroundImage: `url('${api.ip}${api.imgSrc}${info[1].cover}')`,
                            }"
                            class="infoImage"
                        ></em>
                        <!-- 按钮 -->
                        <div class="readContine_new">
                            <span class="readTitle" @click="toInforMain(info[1].id)"
                                >继续阅读 ></span
                            >
                        </div>
                    </div>
                </div>
                <div class="info_button" @click="toInfor()">更多 ></div>
            </div>
            <!-- 加盟我们 -->
            <div class="information_join">
                <p @click="toJoin()">加入我们</p>
                <img
                    @click="toJoin()"
                    class="join_play"
                    src="../assets/images/icon/play-white.png"
                    alt=""
                />
            </div>
        </div>
        <!-- ---------------------------------- 购物车、订阅 ---------------------------------- -->
        <div class="subscribe">
            <!-- 购物车 -->

            <div class="car">
                <img
                    class="index_car"
                    src="../assets/images/index-car.png"
                    alt=""
                />
                <!-- <el-dialog
          title="提示"
          :visible.sync="centerDialogVisible"
          width="25%"
          center
        >
          <p>即将上线，敬请期待</p>
        </el-dialog> -->
                <!-- <a-popconfirm title="即将上线，敬请期待" style="width:100%" class="propcon"> -->
                <div class="subscribe_box">
                    <span @click="openDialog">购物车</span>
                    <img
                        @click="openDialog"
                        class="subscribe_play"
                        src="../assets/images/icon/play-white.png"
                        alt=""
                    />
                </div>
                <!-- </a-popconfirm>  -->
            </div>
            <!-- 订阅我们 -->
            <div class="us">
                <img
                    class="index_subscribe"
                    src="../assets/images/index-subscribe.png"
                    alt=""
                />
                <div class="subscribe_box">
                    <span @click="toSubscribe()">订阅我们</span>
                    <img
                        @click="toSubscribe()"
                        class="subscribe_play"
                        src="../assets/images/icon/play-white.png"
                        alt=""
                    />
                </div>
            </div>
        </div>
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import TransverseRotation from '@/components/TransverseRotation';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import Axios from 'axios';
export default {
    components: {
        Header,
        Footer,
        TransverseRotation,
        swiper,
        swiperSlide,
    },
    data() {
        return {
            agentAccount: [],
            centerDialogVisible: false,
            centerTygVisible: false,
            seconds: 5,
            show1: true,
            show2: false,
            confirmLoading: false,
            visible: true,
            visible1: false,
            imgList4: [],
            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                // 显示分页
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true, //允许分页点击跳转
                },
                // 设置点击箭头
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
            // 轮播图组件默认高度
            autoHeight: '899px',
            value1: '',
            value2: undefined,
            provinceArr: [],
            cityArr: [],
            phoneR: false,
            formData1: {
                modelsValue: '', //机型
                provinceValue: undefined, //省份
                cityValue: undefined, //城市
                customerValue: undefined, //客户
                nameValue: '', //姓名
                adressValue: '', //详情地址
                phoneValue: '', //手机号
                serviceAddress: '', //服务地址
                eamilValue: '', //电子邮箱
                companyValue: '', //公司名称
                codeOne: undefined,
                codeTwo: undefined,
            },
            list2: [
                {
                    url: require('../assets/images/index-RA488.png'),
                    title: 'RA488',
                    main: '高效空气净化器',
                    tabId: 0,
                },
                {
                    url: require('../assets/images/index-RA800.png'),
                    title: 'RA800',
                    main: '高效空气净化器',
                    tabId: 1,
                },
                {
                    // url: require('../assets/images/index-PN1.jpg'),
                    // title: 'PN-02B',
                    // main: '等离子纳米空气净化器',
                    // tabId: 2,
                },
                {
                    // url: require('../assets/images/index-PN21.png'),
                    // title: 'PN-02W',
                    // main: '等离子纳米空气净化器',
                    // tabId: 2,
                },
            ],
            info: [], // 企业资讯的数据
        };
    },
    mounted() {
        this.getshengfen();
        let that = this;
        // 监听窗口大小
        window.onresize = function windowResize() {
            var w = window.innerWidth;
            var h = 890;
            if (w > 1980) {
                h = 899;
            } else {
                h = 0.45 * w;
            }
            that.autoHeight = h + 'px';
        };
        this.getImagesUrl();

        /** 获取企业资讯数据 **/
        this.corporateNews();
        this.getAgentAccount();
    },
    methods: {
        getAgentAccount() {
            var that = this;
            Axios.get(
                `${this.api.ip}/jeecg-boot/h5/H5Controller2/getAgentAccount`
            ).then((res) => {
                if (res.data.success === true) {
                    that.agentAccount = res.data.result;
                }
            });
        },
        qingKong() {
            var that = this;
            that.formData1.codeTwo = null;
        },
        refuseToCast() {
            this.centerDialogVisible = false;
            this.centerTygVisible = false;
        },
        allowToCast() {
            this.centerDialogVisible = false;
            this.centerTygVisible = false;
        },
        openDialog() {
            this.$message.warning('即将上线，敬请期待', 1.5);

            // this.centerDialogVisible = true;
            // var interval = setInterval(() => {
            //   this.seconds--;
            //   if (this.seconds <= 0) {
            //     this.centerDialogVisible = false;
            //     clearInterval(interval);
            //   }
            // }, 1000);
            // this.seconds = 1;
        },
        opentyg() {
            this.$message.warning('即将上线，敬请期待', 1.5);

            // this.centerDialogVisible = true;
            // var interval = setInterval(() => {
            //   this.seconds--;
            //   if (this.seconds <= 0) {
            //     this.centerDialogVisible = false;
            //     clearInterval(interval);
            //   }
            // }, 1000);
            // this.seconds = 1;
        },

        showCont() {
            this.show1 = !this.show1;
            this.show2 = !this.show2;
        },
        showModal() {
            this.visible1 = true;
        },
        handleOk(e) {
            this.ModalText = 'The modal will be closed after two seconds';
            this.confirmLoading = true;

            this.visible1 = false;
            this.confirmLoading = false;
        },
        handleCancel(e) {
            this.visible1 = false;
        },
        /** 获取企业资讯 **/
        corporateNews() {
            Axios.get(
                `${this.api.ip}/jeecg-boot/h5/h5Controller/informationQueryList`
            ).then((res) => {
                this.info = res.data.result.filter((item, index) => {
                    return index < 2;
                });
            });
        },
        phoneRule() {
            var that = this;
            if (that.formData1.phoneValue.length === 0) {
                that.phoneR = false;
                return;
            }
            let rule = /^1[3456789]\d{9}$/;
            if (!rule.test(that.formData1.phoneValue)) {
                this.$message.error('请输入正确的手机号！', 1);
            } else {
                that.phoneR = true;
            }
        },
        //预约空气检测
        yyAirjiance() {
            if (!this.formData1.provinceValue) {
                this.$message.error('省份选中不能为空！', 1);

                return false;
            }
            if (!this.formData1.cityValue) {
                this.$message.error('城市选中不能为空！', 1);
                return false;
            }
            if (!this.formData1.nameValue) {
                this.$message.error('姓名不能为空！', 1);
                return false;
            }
            if (!this.formData1.phoneValue) {
                this.$message.error('手机号码不能为空！', 1);
                return false;
            }
            if (this.phoneR === false) {
                this.$message.error('请输入正确的手机号！', 1);
                return false;
            }
            if (!this.formData1.codeTwo) {
                this.$message.error('请输入邀请码', 1);
                return false;
            }
            if (
                this.formData1.codeTwo &&
                this.formData1.codeTwo !== 1 &&
                this.formData1.codeTwo !== 2
            ) {
                if (
                    this.agentAccount.indexOf(
                        this.formData1.codeTwo.toString()
                    ) === -1
                ) {
                    this.$message.error('邀请码无效！', 1);
                    return false;
                }
            }
            if (this.formData1.codeTwo < 0) {
                this.formData1.codeTwo = undefined;
            }
            var data = {
                consultingId: 94,
                provinceId: this.formData1.provinceValue,
                cityId: this.formData1.cityValue,
                companyNameCn: this.formData1.nameValue,
                phone: this.formData1.phoneValue,
                inviteCode: this.formData1.codeTwo,
            };
            var url =
                'http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/addWyWCustomerConsultation';
            Axios.post(url, data).then((res) => {
                if (res.data.success == true) {
                    this.$message.success('安排成功', 1);
                    this.formData1 = {
                        modelsValue: '', //机型
                        provinceValue: undefined, //省份
                        cityValue: undefined, //城市
                        customerValue: undefined, //客户
                        nameValue: '', //姓名
                        adressValue: '', //详情地址
                        phoneValue: '', //手机号
                        serviceAddress: '', //服务地址
                        eamilValue: '', //电子邮箱
                        codeOne: undefined,
                        codeTwo: undefined,
                        companyValue: '', //公司名称
                    };
                }
            });
        },
        getImagesUrl() {
            var that = this;
            var url =
                'http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/getBannerImages?location=' +
                95;
            Axios.get(url).then((res) => {
                if (res.data.success === true) {
                    for (let i = 0; i < res.data.result.length; i++) {
                        that.imgList4.push({
                            lujing: res.data.result[i].backup1,
                            imgUrl: res.data.result[i].picUrl,
                            remarks: res.data.result[i].remarks,
                            video: res.data.result[i].backup2,
                        });
                    }
                }
            });
        },
        getshengfen() {
            var that = this;
            var url =
                'http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/getWyProvince';
            // var url =  "http://192.168.1.120:8082/jeecg-boot/h5/h5Controller/getWyProvince";
            Axios.get(url).then((res) => {
                if (res.data.success == true) {
                    that.provinceArr = res.data.result;
                }
            });
        },
        // 获取城市
        getCity() {
            this.formData1.cityValue = undefined;
            var that = this;
            var data = {
                provinceId: that.formData1.provinceValue,
            };
            var url =
                'http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/getWyCity?provinceId=' +
                data.provinceId;
            // var url = "http://192.168.1.120:8082/jeecg-boot/h5/h5Controller/getWyCity?provinceId="+data.provinceId;
            Axios.get(url).then((res) => {
                if (res.data.success == true) {
                    that.cityArr = res.data.result;
                }
            });
        }, // 跳转订阅我们
        toSubscribe() {
            this.$router.push({
                path: '/subscribe',
            });
        },
        // 跳转2D体验馆
        toExperience() {
            this.$router.push({
                path: '/experience',
            });
        },
        // 跳转企业资讯详情
        toInforMain(val) {
            this.$router.push({
                path: '/information_main',
                query: { setId: val },
            });
        },
        // 跳转企业资讯
        toInfor() {
            this.$router.push({
                path: '/news',
            });
        },
        toDetection() {
            this.$router.push({
                path: '/airtest',
            });
        },
        // banner点击页面跳转
        tiaoZhuan(val) {
            var that = this;
            if (that.imgList4[val].lujing === null) {
                return;
            }
            window.location.href = that.imgList4[val].lujing;
        },
        // 跳转清洁页面
        toCare() {
            this.$router.push({
                path: '/care',
            });
        },
        // 跳转加入我们
        toJoin() {
            this.$router.push({
                path: '/join',
            });
        },
        open3() {
            // this.$message.warning("即将上线，敬请期待",1);
            // this.$notification.open({
            //     message: "即将上线，敬请期待",
            //     style: {
            //         width: "400px",
            //         marginLeft: `${0 - 700}px`,
            //         //  marginTop: `${100}px`,
            //     },
            // });
        },
    },
};
</script>

<style lang="less" scoped>
// ---------------------------- 轮播海报 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
}

// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    // 蔚然新创·诺守健康
    .slogan_one {
        font-size: 100px;
    }
    // 拥抱
    .slogan_two {
        font-size: 120px;
        position: absolute;
        top: 23%;
        left: 22%;
    }
    // 蓝天绿地
    .slogan_tree {
        font-size: 86px;
        position: absolute;
        bottom: 35%;
        right: 15%;
    }
    // 呼吸得到的
    .slogan_four {
        font-size: 80px;
        position: absolute;
        top: 25%;
        left: 8%;
    }
    // 美感生活
    .slogan_five {
        font-size: 120px;
        position: absolute;
        bottom: 37%;
        right: 8%;
    }
    // 智造绿色生活
    .slogan_six {
        font-size: 120px;
    }
    // 预约空气测检服务
    .slogan_seven {
        font-size: 80px;
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    // 蔚然新创·诺守健康
    .slogan_one {
        font-size: 60px;
    }
    // 拥抱
    .slogan_two {
        font-size: 80px;
        position: absolute;
        top: 23%;
        left: 23%;
    }
    // 蓝天绿地
    .slogan_tree {
        font-size: 46px;
        position: absolute;
        bottom: 35%;
        right: 25%;
    }
    // 呼吸得到的
    .slogan_four {
        font-size: 40px;
        position: absolute;
        top: 29%;
        left: 12%;
    }
    // 美感生活
    .slogan_five {
        font-size: 80px;
        position: absolute;
        bottom: 40%;
        right: 12%;
    }
    // 智造绿色生活
    .slogan_six {
        font-size: 80px;
    }
    // 预约空气测检服务
    .slogan_seven {
        font-size: 40px;
    }
}
.banner {
    width: 100%;
    height: 4.682rem;
    position: relative;
    /deep/.el-carousel__container {
        height: 100%;
    }
    .banner_box {
        width: 100%;
        height: 100%;
        position: relative;
        img[lazy='loading'] {
            width: 15%;
            height: 40%;
         margin-left: 40%;
            margin-top: 8%;
        }
    }
    // 海报图片
    img {
        width: 100%;
        height: 100%;
        cursor: pointer;
    }
    // 蔚然新创·诺守健康
    .slogan_one {
        width: 100%;
        color: #365c56;
        letter-spacing: 20px;
        text-align: center;
        position: absolute;
        bottom: 11%;
        margin: 0;
        line-height: 80px;
        span {
            font-size: 80px;
        }
    }
    // 拥抱
    .slogan_two {
        font-weight: lighter;
        color: #505155;
        letter-spacing: 20px;
    }
    // 蓝天绿地
    .slogan_tree {
        font-weight: bold;
        color: #505155;
        letter-spacing: 20px;
    }
    // 呼吸得到的
    .slogan_four {
        color: #505155;
        font-weight: bold;
        letter-spacing: 10px;
    }
    // 美感生活
    .slogan_five {
        font-weight: lighter;
        color: #505155;
        letter-spacing: 10px;
    }
    // 智造绿色生活
    .slogan_six {
        width: 100%;
        color: #4f5955;
        letter-spacing: 10px;
        text-align: center;
        position: absolute;
        top: 10%;
        left: 0;
    }
    // 预约空气测检服务
    .slogan_seven {
        width: 100%;
        color: #4f5955;
        letter-spacing: 20px;
        text-align: center;
        position: absolute;
        bottom: 10%;
        left: 0;
    }
}

// ---------------------------- 宣传标语 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .propaganda {
        p {
            font-size: 60px;
            height: 365px;
        }
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .propaganda {
        p {
            font-size: 40px;
            height: 305px;
        }
    }
}
.propaganda {
    width: 100%;
    background: url('../assets/images/index-bg-green.png') no-repeat;
    background-size: 100% 100%;
    // 标语
    p {
        font-weight: lighter;
        text-align: center;
        color: #ffffff;
        letter-spacing: 5px;
        line-height: 1.7;
        margin: 0;
        padding-top: 3.5%;
    }
}

// ---------------------------- 产品展示 ---------------------------------
.product {
    width: 100%;
    padding: 2% 0 6% 0;
    background-color: white;
}

// ---------------------------- 产品理念 ---------------------------------
.concept {
    width: 100%;
    height: 870px;
    position: relative;
    // 背景图
    .concept_bg {
        width: 100%;
        height: 100%;
    }
    // 内容
    .concept_main {
        width: 46%;
        position: absolute;
        top: 28%;
        left: 0;
        // 文字
        p {
            margin: 0 auto;
            padding-left: 27%;
            font-size: 26px;
            color: #1b2d56;
            letter-spacing: 2px;
            line-height: 1.7;
        }
        // LOGO
        img {
            display: block;
            margin: 0 auto;
        }
        .concept_logo {
            width: 345px;
            margin-top: 45px;
        }
        // 播放图标
        .concept_play {
            width: 55px;
            margin-top: 17px;
        }
    }
}

// ---------------------------- 产品关怀 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    // 内容
    .care_main {
        width: 35%;
        // LOGO
        .care_logo {
            width: 407px;
        }
        // 空检、维修、保养
        .care_box {
            div {
                font-size: 65px;
            }
        }
        // 播放图标
        .care_play {
            width: 75px;
        }
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    // 内容
    .care_main {
        // LOGO
        .care_logo {
            width: 317px;
        }
        // 空检、维修、保养
        .care_box {
            div {
                font-size: 50px;
            }
        }
        // 播放图标
        .care_play {
            width: 55px;
        }
    }
}
.care {
    width: 100%;
    height: 751px;
    position: relative;
    // 背景图
    .care_bg {
        width: 100%;
        height: 100%;
    }
    // 内容
    .care_main {
        position: absolute;
        top: 23%;
        right: 9%;
        // LOGO
        img {
            display: block;
            margin: 0 auto;
        }
        // 空检、维修、保养
        .care_box {
            width: 100%;
            border-bottom: 7px solid #1b2d56;
            display: flex;
            align-items: center;
            justify-content: space-around;
            padding: 50px 0 31px 0;
            margin-bottom: 56px;
            div {
                color: #1b2d56;
                letter-spacing: 13px;
                padding: 0 20px;
            }
            // 竖线
            .vertical {
                border-left: 5px solid #1b2d56;
                border-right: 5px solid #1b2d56;
                padding-left: 30px;
            }
        }
        // 播放图标
        .care_play {
            cursor: pointer;
        }
    }
}

// ---------------------------- 2D体验馆 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    // 内容
    .experience_main {
        position: absolute;
        top: 12%;
        left: 0;
        p {
            font-size: 44px;
        }
        // 图标
        .corrugated {
            width: 167px;
        }
        // 标题
        div {
            width: 450px;
            font-size: 60px;
        }
        // 播放图标
        .experience_play {
            width: 68px;
        }
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    // 内容
    .experience_main {
        position: absolute;
        top: 25%;
        left: 0;
        p {
            font-size: 28px;
            font-weight: lighter;
        }
        // 图标
        .corrugated {
            width: 117px;
        }
        // 标题
        div {
            width: 400px;
            font-size: 42px;
        }
        // 播放图标
        .experience_play {
            width: 55px;
        }
    }
}
.experience {
    width: 100%;
    // height: 869px;
    position: relative;
    // 背景图
    .experience_bg {
        width: 100%;
        height: 100%;
    }
    // 内容
    .experience_main {
        width: 50%;
        // 文案
        p {
            color: #ffffff;
            letter-spacing: 3px;
            line-height: 1.8;
            text-align: center;
            margin: 0;
        }
        // 图标
        .corrugated {
            display: block;
            margin: 0 auto;
            margin-top: 55px;
            margin-bottom: 50px;
        }
        // 标题
        div {
            color: #ffffff;
            text-align: center;
            border-bottom: 7px solid #ffffff;
            margin: 0 auto;
            padding-bottom: 25px;
            margin-bottom: 25px;
        }
        // 播放图标
        .experience_play {
            display: block;
            margin: 0 auto;
            cursor: pointer;
        }
    }
}

// ---------------------------- 空气检测服务 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    // 左侧标语
    .service_slogan {
        // 标语
        span {
            font-size: 55px;
            position: absolute;
            bottom: 23%;
            right: 14%;
        }
    }
    // 右侧表单
    .service_form {
        // 标题
        .form_title {
            margin-bottom: 10px;
            p {
                font-size: 46px;
            }
            img {
                width: 70px;
                height: 70px;
            }
        }
        // 表单
        .index-quyu-ss {
            width: 80%;
            .index-quyu-xiala {
                font-size: 42px;
                font-weight: lighter;
            }
        }
        .index-quyu-btt {
            font-size: 40px;
            margin-top: 2.5%;
            font-weight: lighter;
            margin-right: 11%;
        }
    }
    .service /deep/ .el-input__inner {
        font-size: 42px;
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    // 左侧标语
    .service_slogan {
        // 标语
        span {
            font-size: 45px;
            position: absolute;
            bottom: 33%;
            right: 14%;
        }
    }
    // 右侧表单
    .service_form {
        // 标题
        .form_title {
            margin-bottom: 60px;
            p {
                font-size: 36px;
            }
            img {
                width: 55px;
                height: 55px;
            }
        }
        // 表单
        .index-quyu-ss {
            width: 60%;
            .index-quyu-xiala {
                font-size: 20px;
            }
        }
        .index-quyu-btt {
            font-size: 20px;
            margin-top: 4%;
            margin-right: 20%;
        }
    }
    .service /deep/ .el-input__inner {
        font-size: 20px;
    }
}
.service {
    width: 100%;
    height: 871px;
    background: url('../assets/images/index-service.png') no-repeat;
    background-size: 100% 100%;
    background-position: center;
    display: flex;
    // 左侧标语
    .service_slogan {
        width: 50%;
        height: 100%;
        position: relative;
        // 标语
        span {
            color: #450c70;
            letter-spacing: 12px;
        }
    }
    // 右侧表单
    .service_form {
        width: 50%;
        // 标题
        .form_title {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 45px;
            p {
                color: #ffffff;
                letter-spacing: 8px;
                margin: 0;
                cursor: pointer;
            }
            img {
                margin-left: 28px;
                cursor: pointer;
            }
        }
        // 表单
        .index-quyu-ss {
            display: flex;
            margin: 0 auto;
            text-align: center;
            align-items: center;
            border-bottom: 1px solid #b6b8b6;
            height: 120px;
            .index-quyu-xiala {
                display: block;
                background: none;
                border: none;
                width: 95%;
                color: #b6b8b6;
            }
            ::-webkit-input-placeholder {
                color: #fff !important;
            }
        }
        .index-quyu-btt {
            float: right;
            color: #fff;
        }
    }
}
.service /deep/ .el-input__inner {
    background-color: #5a357e;
    border: none;
    color: #b6b8b6;
    font-weight: lighter;
}

// ---------------------------- 企业资讯 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    // 标题
    .infor_title {
        font-size: 58px;
        font-weight: normal;
        padding-top: 31px;
    }
    // 资讯
    .content_main {
        width: 36%;
        height: 100px;
        margin-bottom: 40px;
        // 文字
        p {
            margin: 0;
            font-size: 35px;
            height: 170px !important;
            width: 98% !important;
            margin-top: 20px !important;
        }
           .readTitle{
            font-size: 38px !important;
            line-height: 60px;
        }
        // 图片
        /deep/ .infoImage {
            margin: 20px 0 0 0;
            height: 200px;
            width: 86% !important;
        }
    }
    // 竖线
    .content_line {
        margin: 0 7% 20px 7%;
    }
    // 加盟我们
    .information_join {
        p {
            font-size: 65px;
        }
        // 播放图标
        .join_play {
            width: 75px;
        }
    }
    .infor_main_box {
        margin: 0 auto;
    }
    /deep/ .info_button {
        margin-right: 45% !important;
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    //咨询图片
    .content .news .news_main .news_box /deep/ img {
        width: 83% !important;
    }
    
    // 标题
    .infor_title {
        font-size: 48px;
        font-weight: lighter;
        padding-top: 51px;
    }
    // 资讯
    .content_main {
        padding: 40px 0 0 0;
        // 文字
        p {
            font-size: 20px;
        }
        // 图片
        .infoImage {
            margin: 30px 0 20px 0;
            width: 270px;
            height: 200px;
        }
        
        
    }
    // 竖线
    .content_line {
        margin: 0 15% 20px 9%;
    }
    // 加盟我们
    .information_join {
        p {
            font-size: 50px;
        }
        // 播放图标
        .join_play {
            width: 55px;
        }
    }
    .infor_content {
        margin-right: 5%;
        padding-left: 5%;
        
    }
}
.information {
    width: 100%;
    height: 649px;
    background: url('../assets/images/index-information.png') no-repeat;
    background-size: 100% 100%;
    background-position: center;
    display: flex;
    margin-top: -1px;
    // 资讯
    .information_main {
        width: 50%;
        height: 100%;
        // 标题
        .infor_title {
            color: #a9af00;
            letter-spacing: 10px;
            margin: 0;
            text-align: center;
            line-height: 1;
        }
        // 横线
        .infor_line {
            width: 356px;
            border-bottom: 8px solid #a9af00;
            margin: 0 auto;
            margin-top: 26px;
        }
     
        // 内容
        .infor_content {
            width: 100%;
            display: flex;
            justify-content: center;
            // 资讯
            .content_main {
                // 文字
                p {
                    margin: 0;
                    color: #595757;
                    line-height: 1.5;
                    letter-spacing: 0px;
                    min-height: 70px;
                    width: 275px;
                    height: 10%;
                }
                // 图片
                .infoImage {
                    display: inline-block;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                }
                // 按钮
                // pc端继续阅读样式
                span {
                    font-size: 20px;
                    color: #595757;
                    letter-spacing: 2px;
                    cursor: pointer;
                }
            }
            // 竖线
            .content_line {
                height: 413px;
                border-right: 3px solid #a9af00;
            }
        }
        // 按钮
        .info_button {
            width: 140px;
            font-size: 20px;
            color: #ffffff;
            background-color: #a9af00;
            text-align: center;
            line-height: 58px;
            margin: 0 auto;
            cursor: pointer;
        }
    }
    // 加盟我们
    .information_join {
        width: 50%;
        box-sizing: border-box;
        padding-right: 2%;
        p {
            color: #ffffff;
            font-weight: lighter;
            letter-spacing: 10px;
            text-align: center;
            margin: 0;
            padding-top: 27%;
            cursor: pointer;
        }
        // 播放图标
        .join_play {
            display: block;
            margin: 0 auto;
            margin-top: 30px;
            cursor: pointer;
        }
    }
}

// ---------------------------- 购物车、订阅 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    // 标题按钮
    .subscribe_box {
        span {
            font-size: 64px;
            font-weight: normal;
        }
        // 播放图标
        .subscribe_play {
            width: 75px;
        }
    }
   
    /deep/ openDialog {
        padding: 200px 200px !important;
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    // 标题按钮
    .subscribe_box {
        span {
            font-size: 44px;
            font-weight: lighter;
        }
        // 播放图标
        .subscribe_play {
            width: 55px;
        }
    }


}
.subscribe {
    width: 100%;
    height: 649px;
    overflow: hidden;
    background: url('../assets/images/index-color.png') no-repeat;
    background-size: 100% 100%;
    background-position: center;
    display: flex;
    // 购物车
    .car {
        width: 50%;
        // 插图
        .index_car {
            width: 673px;
            display: block;
            margin: 0 auto;
            padding: 119px 0 80px 0;
        }
    }
    // 订阅我们
    .us {
        width: 50%;
        // 插图
        .index_subscribe {
            width: 479px;
            display: block;
            margin: 0 auto;
            padding: 70px 0 53px 0;
        }
    }
    // 标题按钮
    .subscribe_box {
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
            color: #ffffff;
            letter-spacing: 8px;
            cursor: pointer;
        }
        // 播放图标
        .subscribe_play {
            margin-left: 20px;
            cursor: pointer;
        }
    }
}
.propk {
    width: 100%;
    position: absolute;
    top: 45%;
    text-align: center;
}
.banner .bfbtn {
    width: 110px;
    height: 70px;
}
/deep/ .el-popover {
    background: 0 !important;
    border: 0 !important;
}

.ant-carousel /deep/ .slick-slide {
    text-align: center;
    height: 899px;
    line-height: 160px;
    background: #364d79;
    overflow: hidden;
}
.ant-carousel /deep/ .slick-slide img {
    width: 100%;
}
.ant-carousel /deep/ .custom-slick-arrow {
    width: 50px;
    height: 50px;
    font-size: 50px;
    color: #fff;
    border-radius: 25px;
    background-color: rgba(31, 45, 61, 0.11);
    opacity: 0.5;
}
.ant-carousel /deep/ .custom-slick-arrow:before {
    display: none;
}
.ant-carousel /deep/ .custom-slick-arrow:hover {
    opacity: 0.5;
}
.ant-carousel /deep/ .slick-slide h3 {
    color: #fff;
}

/deep/ .el-dialog__header {
    text-align: left;
}
/deep/ .el-dialog__body {
    text-align: center;
}
/deep/ .el-dialog__wrapper {
    position: fixed;
    top: 20%;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
}
/deep/ openDialog {
    padding: 40px 40px !important;
}
.index-qi-pa-rig-san-quyu {
    margin-top: 50px;
}
</style>
<style lang="less">
/deep/.ant-message-notice-content {
    font-size: 100px !important;
    font-weight: bold !important;
}

.readContine_new {
    line-height: 12px;
    height: 12px;
    margin-top: 5px;
}

.form-icon {
    width: 64px;
}
</style>





// WEBPACK FOOTER //
// src/view/index.vue